import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-split-custom-amount",
  templateUrl: "./split-custom-amount.html",
  styleUrls: ["./split-custom-amount.scss"],
  standalone: false
})
export class SplitCustomAmountComponent {
  @Input() customAmount = 0;
  @Input() billAmount = 0;
  @Input() totalRemaining = 0;

  @Output() amountChange = new EventEmitter<number>();
  @Output() submit = new EventEmitter<void>();

  onAmountInput(value: number): void {
    if (!Number.isFinite(value) || value < 1) {
      this.amountChange.emit(0);
      return;
    }
    const next = Math.min(value, this.totalRemaining);
    this.amountChange.emit(next);
  }

  onAmountBlur(input: HTMLInputElement): void {
    input.value = this.customAmount ? this.customAmount.toString() : "";
  }
}
